import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <h4>{`I have made a career shift towards learning web development and frontend technologies. For the past 1.5 years, I have been spending countless hours learning about HTML, CSS, Javascript ES6, and React. After all of this effort, I have come to like creating web applications and user interfaces with these aforementioned technologies. In 2020 I successfully finished a 6-month bootcamp in React. Now I am applying the things I have learned in to real-life web applications using React.js and javascript Es6. My goal is to start my career as a junior web developer and create beautiful, functional web apps.`}</h4>
    <p>{`What do you think of this portfolio?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      